import store from "../store";

const SESSION_TAB_KEY = "dashboardTab";

let dashboardRouter = null;

export function setDashboardRouter(router) {
  dashboardRouter = router;
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/** Resolve active tab from route query, browser URL, or session backup. */
export function resolveDashboardTab(routeLike) {
  const fromRoute = routeLike?.query?.tab;
  if (fromRoute != null && String(fromRoute).trim() !== "") {
    return String(fromRoute).trim();
  }

  if (typeof window !== "undefined") {
    const fromUrl = new URLSearchParams(window.location.search).get("tab");
    if (fromUrl) {
      return fromUrl;
    }
  }

  if (typeof sessionStorage !== "undefined") {
    const stored = sessionStorage.getItem(SESSION_TAB_KEY);
    if (stored) {
      return stored;
    }
  }

  return null;
}

export function readDashboardTabQuery(routeLike) {
  const tab = resolveDashboardTab(routeLike);
  return tab ? { tab } : {};
}

export function withDashboardTabQuery(routeLike, extraQuery = {}) {
  return { ...readDashboardTabQuery(routeLike), ...extraQuery };
}

export function buildDashboardRoute(routeLike, extraQuery = {}) {
  return {
    name: "Dashboard",
    query: withDashboardTabQuery(routeLike, extraQuery),
  };
}

/** Switch store view flags to match a dashboard tab (safe to call before tab panels mount). */
export function applyDashboardTabToStore(tabName) {
  if (!tabName) return;

  const viewKey = tabName.includes(" ")
    ? tabName
    : ["accountUsers", "smartCards", "shopfront", "giftCards", "liveChat", "influencers", "partnerActivity", "guides"].includes(
          tabName,
        )
      ? tabName
      : tabName.toLowerCase();

  store.state.currentDashboardView = Object.keys(store.state.currentDashboardView).reduce(
    (acc, key) => {
      acc[key] = key === viewKey;
      return acc;
    },
    {},
  );

  if (tabName === "promoter") {
    store.state.dashBoardView = "Promoter";
  } else if (tabName === "giftCards") {
    store.state.dashBoardView = "Gift Cards";
  } else if (tabName === "funnels") {
    store.state.dashBoardView = "Pipelines";
  } else if (tabName === "accountUsers") {
    store.state.dashBoardView = "Account Users";
  } else if (tabName === "liveChat") {
    store.state.dashBoardView = "Live chat";
  } else if (tabName === "influencers") {
    store.state.dashBoardView = "Influencers";
  } else if (tabName === "partnerActivity") {
    store.state.dashBoardView = "Partner Activity";
  } else if (tabName === "guides") {
    store.state.dashBoardView = "Guides";
  } else if (
    ["customers", "warranties", "scripts", "inventory", "employees", "integrations", "referrals", "feedback", "bookings", "leads", "finance", "services", "gallery", "settings"].includes(
      tabName,
    )
  ) {
    store.state.dashBoardView = capitalizeFirstLetter(tabName);
  } else if (tabName === "shopfront") {
    store.state.dashBoardView = "Shopfront";
  }
}

export function syncDashboardTabQuery(tabName) {
  if (!dashboardRouter || !tabName) return;

  const current = dashboardRouter.currentRoute.value;
  const dashboardSubpath = current.path.slice("/dashboard".length);
  if (!current.path.startsWith("/dashboard") || dashboardSubpath.startsWith("/")) {
    return;
  }

  dashboardRouter
    .replace({
      path: current.path,
      query: { ...current.query, tab: tabName },
    })
    .catch(() => {});
}

export function persistDashboardTab(tabName) {
  if (!tabName) return;
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.setItem(SESSION_TAB_KEY, tabName);
  }
  syncDashboardTabQuery(tabName);
}

/** Apply tab from URL/session to the store as early as possible on dashboard load. */
export function bootstrapDashboardTabFromRoute(routeLike) {
  const tab = resolveDashboardTab(routeLike);
  if (tab) {
    applyDashboardTabToStore(tab);
    persistDashboardTab(tab);
  }
}
